import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { Snackbar, Alert } from "@mui/material";
import { useAuth } from "../components/AuthProvider.tsx";
import Business from "../models/Business.tsx";
import CaseManager from "../models/CaseManager.tsx";
import MenuComponent from "../components/Menu.tsx";

function AdminProfile() {
  const { authorization, SetAuthorization } = useAuth();

  const NewBusiness = () => {
    const business: Business = {
      Token: "",
      BusinessId: 0,
      CaseManagerId: null,
      CaseManager: null,
      OperatingName: "",
      DesignationNumber: "",
      LegalName: "",
      Address: "",
      City: "",
      PostalCode: "",
      OperatingSectorId: null,
      BusinessSizeId: null,
      YearsOfOperationId: null,
      FirstName: "",
      LastName: "",
      Telephone: "",
      Email: "",
      Password: "",
      IsAdministrator: false,
      IsTermsAndConditions: false
    }
    return business;
  }

  const navigate = useNavigate();
  const { businessId } = useParams();
  const [business, SetBusiness] = useState(NewBusiness());
  const [managers, SetManagers ] = useState<CaseManager[]>([]);
  const [display_error, SetError] = useState(false);
  const [errors, SetErrors] = useState<string[]>([]);

  useEffect(() => {
    fetch("/api/casemanager")
      .then(response => response.json())
      .then(data => SetManagers(data))
      .catch(error => console.error(error));    

    if (authorization && businessId) {
      fetch("/api/business?token=" + authorization.Token + "&businessId=" + businessId)
        .then(response => response.json())
        .then(data => SetBusiness(data))
        .catch(error => console.log(error));
    }
  }, [authorization]);

  const Submit = (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    // Validate business data
    let validation_errors: string[] = [];
    if (!business.OperatingName ||
      !business.FirstName ||
      !business.LastName) {
      validation_errors.push("One or more fields are missing.");
    }

    if (!business.Email) {
      validation_errors.push("Email address is missing.");
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(business.Email)) {
      validation_errors.push("Email address is not in a valid format.");
    }    
    
    // Validate designation number uniqueness
    const credentials = {
      DesignationNumber: business.DesignationNumber,
      Password: ""
    }
    const validation_options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(credentials)
    };

    fetch("/api/validation", validation_options)
      .then(response => response.text())
      .then(data => {
        const businessId = Number(data);
        if (businessId > 0 && business.BusinessId != businessId) {
          validation_errors.push("Designation Number is already in use.");
        }

        SetErrors(validation_errors);
        SetError(validation_errors.length > 0);

        if (validation_errors.length === 0) {
          SaveBusiness();
        }
      })
      .catch(error => console.log(error));
  }

  const SaveBusiness = () => {
    business.Token = authorization.Token;
    const options = {
      method: business.BusinessId > 0 ? "PATCH" : "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(business)
    };

    fetch("/api/business", options)
      .then(response => response.json())
      .then(data => {navigate("/admin/profiles")})
      .catch(error => console.error(error));
  }

  const OnChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    SetBusiness((prevState) => ({ ...prevState, [name]: value }));
  }

  return (
    <>
      <Snackbar open={display_error} onClose={() => SetError(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity="error" variant="filled" sx={{ width: "100%", padding: 2 }}>
          Employer could not be {!business ? <>created</> : <>updated</>} due to the following errors.
          <ol>
            {errors.map((error, index) =>
              <li key={index}>{error}</li>
            )}
          </ol>
        </Alert>
      </Snackbar>

      <MenuComponent page={business.BusinessId === 0 ? "Create Employer Profile" : "Update Employer Profile"} />

      <section id="main">
        <div className="container">
          <p>Please note, <strong>all fields are mandatory</strong> unless otherwise indicated in order to submit an application.</p>
          <form onSubmit={Submit}>
            <p>
              <label>Employer Operating Name
                <input type="text" name="OperatingName" value={business.OperatingName} onChange={OnChange} required maxLength={100} />
              </label>
            </p>
            <p>
              <label>Designation Number
                <input type="text" name="DesignationNumber" value={business.DesignationNumber} onChange={OnChange} required maxLength={50} />
              </label>
            </p>
            <p>
              <label>Case Manager
                <select name="CaseManagerId" value={business.CaseManagerId} onChange={OnChange}>
                  <option value=""></option>
                  {managers.map(manager =>
                    <option key={manager.BusinessId} value={manager.BusinessId}>{manager.Name}</option>
                  )}
                </select>
              </label>
            </p>
            <p>
              <label>First Name
                <input type="text" name="FirstName" value={business.FirstName} onChange={OnChange} required maxLength={50} />
              </label>
            </p>
            <p>
              <label>Last Name
                <input type="text" name="LastName" value={business.LastName} onChange={OnChange} required maxLength={50} />
              </label>
            </p>
            <p>
              <label>Email Address
                <input type="text" name="Email" value={business.Email} onChange={OnChange} maxLength={255} />
              </label>
            </p>
            <p>
              <label>Password
                <input type="password" name="Password" value={business.Password} onChange={OnChange} maxLength={50} />
              </label>
            </p>
            <p className="formButton"><input type="submit" value={business.BusinessId === 0 ? "Create Employer" : "Update Employer"} /></p>
          </form>
        </div>
      </section>
    </>
  );
}

export default AdminProfile;